import { Map as IMap } from 'immutable';



export const snareURL = 'https://mpsnare.iesnare.com/snare.js';


const getBlackboxExtras = blackbox => IMap({
    blackbox,
    blackboxUrl: window.location.href
});

export const loadSnare = async () => getBlackboxExtras(''); 

export default loadSnare;
